<template>
  <div>
  <section class="">
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
        <div class="container">
            <ol class="breadcrumb hidden-xs">
                <li><a href="/">首頁</a></li>
                <li class="active">隱私權政策</li>
            </ol>
            <div class="row">
                <div class="col-sm-2">
                    <div class="aside_menu">
                        <h4 class="title">隱私權政策</h4>
                        <ul class="list-unstyled">
                            <li class="item"><a href="/privacy">隱私權政策</a></li>
                            <li class="item"><a href="/member_policy">會員條款</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-sm-10">
                    <h3 class="title hidden-xs hidden-sm">隱私權政策</h3>
                    <div class="editor">
                    <p>愛幫您股份有限公司(以下簡稱 i80)非常重視您的隱私權，請您閱讀以下有關隱私權保護政策的更多內容：</p>
<br/>
<p>
壹、本政策涵蓋的內容包括：i80如何處理蒐集或收到的個人資料 (包括與您過去使用 i80產品及服務相關的資料）。個人資料是指得以識別您的身分且未公開的資料，如姓名、地址、電子郵件地址或電話號碼等。
</p>

<p>
貳、本隱私權保護政策只適用於 i80公司及旗下關係企業等。本政策不適用於非 i80所有或控制的公司，也不適用於非 i80僱用或管理之人。
</p>

<p>
參、資料蒐集及使用：
</p>
<p>
一、在您註冊 i80帳號、使用 i80系統、產品或服務、瀏覽 i80網頁或某些合作夥伴的網頁，以及參加宣傳活動或贈獎遊戲時，i80會蒐集您的個人資料。i80也可能將商業夥伴或其他企業所提供的關於您的資訊與 i80所擁有的您的個人資料相結合。
</p>

<p>
二、當您在 i80註冊時，我們會詢問您的姓名、電子郵件地址、出生年月日期、性別及郵遞區號等資料。在您使用某些特定服務時，我們可能還會詢問您的住址、身分證號碼以及您數位資產的相關資料。在您註冊 i80帳號並登入我們的服務後，我們就能辨別您的身分。 您得自由選擇是否提供個人資料給我們，但若特定資料欄位係屬必填欄位者，您若不提供該等資料則無法使用相關的i80系統、產品及服務。
</p>
<p>
三、i80蒐集您與我們或我們的商業夥伴交易的資料，包括您使用我們所提供服務的相關資料。
</p>

<p>
四、i80也自動接收並記錄您電腦和瀏覽器上的資料，包括 IP位址、cookie中的資料、軟體和硬體屬性以及您瀏覽的網頁紀錄。
</p>

<p>
五、在您使用i80產品及服務期間，i80及其相關企業得於全球地區將資料用作以下用途：客製化廣告及您看到的網頁內容、滿足您對產品和服務的要求、改進我們的服務、聯絡您、進行研究，以及提供內部及外部客戶不載有個人資料之市場分析或業務報告。
</p>

<p>
  肆、i80蒐集、處理及利用個人資料之特定目的如下：行銷業務、消費者、客戶管理與服務、資訊通訊服務、網路購物及其他電子商務服務、廣告和商業行為管理業務以及其他契約、類似契約或法律關係管理之事務或業務。
</p>

<br/>
<br/>
<p>
  伍、資料分享與揭露：除非是為了向您提供您所要求的產品或服務、獲得您的授權，或有以下情形，否則 i80不會向任何其他人士或非關係企業提供您的個人資料，或與之分享：
</p>

<p>
一、我們向已簽署保密協議書之代表 i80執行業務或與我們共事的值得信賴的合作夥伴提供這些資料。這些公司可能會將您的個人資料用於協助 i80就我們和行銷夥伴所提供產品及服務的事宜，與您進行溝通。但這些公司無獨立權利分享這些資料。
</p>
<p>
二、我們對傳票、法院命令或法律程序作出回應、取得或行使法律權利，或對訴訟上之請求提出防禦。
</p>
<p>
三、我們認為為了調查和防止非法活動、涉嫌詐欺、對人身安全有潛在威脅的狀況、對i80服務條款的違反，或為了對上述情形採取應對措施，或法律另有規定，而有必要分享您的個人資料時。
</p>
<p>
四、如果i80全部或部分業務被其他公司收購或合併，我們會將您的個人資料移轉給該公司。如果發生這種情況，i80會在您的個人資料被移轉且將適用不同的隱私權政策前通知您。
</p>

<br/>
<p>
陸、i80會根據您的個人資料向您為行銷廣告：
</p>

<p>
一、廣告主 (包括廣告遞送公司) 可能假定那些瀏覽、點閱行銷廣告或與廣告互動的人士符合行銷標準，例如特定地理區域內 18至24 歲的女性。 在您瀏覽行銷廣告或與廣告發生互動時，i80不會向廣告主提供您的任何個人資料。然而，一旦瀏覽廣告或與廣告發生互動，即表示您同意廣告主可能會假定您符合展示型廣告所使用的行銷標準。 i80廣告主包括金融服務提供者 (如銀行、保險代理人、證券經紀人及抵押貸款機構等) 和非金融公司 (如商店、航空公司及軟體公司等)。
</p>

<p>
二、i80與各行各業的供應商、合作夥伴、廣告主及其他服務提供者共用Cookie： i80會在您的電腦上設定並存取i80cookie。i80允許在某些i80網頁上刊登廣告的其他公司在您的電腦上設定並存取cookie。其他公司將根據其自訂的隱私權政策使用其cookie，並非依據本政策。廣告主或其他公司不能存取i80的cookie。
</p>

<br/>
<p>
柒：您可隨時查詢、閱覽、複製及修改個人 i80帳號資料，包括行銷偏好設定：
</p>
<p>
一、i80得不定時在行銷偏好設定頁面上新增新類別的行銷訊息。
</p>
<p>
二、瀏覽此頁面的使用者可選擇退出接收新類別的行銷訊息，或按照所收訊息中的指示取消訂閱這些訊息。
</p>
<p>
三、i80保有權利向您傳送 i80服務相關的特定訊息 (如服務公告、管理訊息等)，這些訊息被視為您i80帳號的一部分，您無法選擇退出接收。
</p>
<p>
  四、如果您要刪除您的i80帳號，請與我們聯繫。關於您的帳號刪除後，會保留在我們存檔紀錄中的資料。
</p>
<br/>

<p>
  捌、機密性和安全性
</p>
<p>
  一、i80會將有權存取您個人資料之員工限於我們合理相信是為了向您提供產品或服務或為了完成工作而需要取得這些資料的員工。
</p>
<p>
  二、i80已採取符合法規要求的實體、電子和程序防護措施，以保護您個人資料的安全。
</p>

<br/>
<p>
  玖、隱私權保護政策修訂
</p>
<p>
  一、i80得不定時修訂本政策。
</p>
<p>
  二、當i80在個人資料的處理上有重大變更時，會將通知傳送到您在i80帳號中指定的主要電子郵件地址，或在i80的網站上張貼告示。
</p>

<br/>
<p>
  拾、如果您有任何問題或建議，請透過客服中心與i80聯繫。
</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  data () {
    return {
      rowData: {}
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Privacy.vue?05567db3